export default "__VITE_ASSET__aA6MhAcJ__"